import { useSize } from 'ahooks';
import { Ellipsis, Grid, Image, Toast } from 'antd-mobile';
import { GridItem } from 'antd-mobile/es/components/grid/grid';
import { GlobalLoadingContext, useThrottledHandler } from 'App';
import img from 'app/img';
import ImgFallback from 'components/dot/img-fallback';
import ImgLoading from 'components/dot/img-loading';
import dayjs from 'dayjs';
import Term from 'pages/webapp/term';
import { useContext, useEffect, useRef, useState } from 'react';
import {
  AiFillCaretRight,
  AiFillCloud,
  AiFillFire,
  AiFillProduct,
  AiOutlineBook,
  AiOutlineHeart,
  AiOutlineSync,
} from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import VideoApi from 'services/apis/cnt/video-api';
import { PagePostDT } from 'services/apis/cnt2/post-api';
import { UserPolyInfoDT } from 'services/apis/sys/user-api';
import { getCountOnSourceType, postSourceTypeMap, postTypeMap } from 'services/gather_bo/_total';
import { bizBaseUrl } from 'services/request';
import { AppConfigDT } from 'stores/appConfigSlice';
import { WindowSizeDT } from 'stores/windowSizeSlice';
import { useWindowSize } from 'usehooks-ts';
import { localDatetime2Date } from 'utils/dateUtil';
import { getItemWithExpiration } from 'utils/localStorageUtil';

const ImageList = (data: {
  maskContent?: any;
  isFake?: boolean;
  column?: number;
  termId: string;
  termName: string;
  postList: PagePostDT[];
  showMore: boolean;
  showChange: boolean;
  onChange?: () => void;
}) => {
  const albumMode: AppConfigDT = useSelector((state: any) => state.appConfigHandle?.albumMode);

  const showGlobalLoading = useContext(GlobalLoadingContext).showGlobalLoading;
  const globalLoading = useContext(GlobalLoadingContext).globalLoading;

  const userPolyInfo = getItemWithExpiration('userPolyInfo') as UserPolyInfoDT;
  const usergroupId = userPolyInfo.vipList?.[0]?.fkUserGroupUuid;
  const collectListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'collect').uuid;
  const historyListId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'history').uuid;
  const favoritelistId = userPolyInfo.videoListDtoList.find((item) => item.listType === 'favorite').uuid;

  const { column = (data?.postList && getCountOnSourceType(data?.postList[0]?.postSourceType)?.column) || 3 } = data;
  const isVertical = data?.postList && getCountOnSourceType(data?.postList[0]?.postSourceType)?.isVertical;

  const windowSize: WindowSizeDT = useSelector((state: any) => state.windowSizeHandle?.windowSize);

  const size = { width: window.innerWidth, height: window.innerHeight };
  const navigate = useNavigate();
  const verticleHeight = size.width / 2.5;
  const horizontalHeight = size.width / 3.5;

  const divRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  // console.log('imageList:' + useLocation().pathname, data.postList);

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) {
        setHeight(entries[0].contentRect.height);
      }
    });

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      observer.disconnect(); // 清理 observer
    };
  }, []);
  return (
    <div
      className=" m-2 rounded-md"
      ref={divRef}
    >
      {/* 标题 */}
      <div className=" p-2 my-2 flex justify-between text-base bg-orange-0 text-slate-100 pt-2 bg-gradient-to-r from-white/80 to-white/30 rounded-md shadow-md">
        <div className="flex justify-center items-center">
          <AiFillProduct
            size={22}
            className="mx-1 mb-1 text-orange-500"
          />
          <div className="text-slate-500">{data.termName}</div>
        </div>
        {!useLocation().pathname.endsWith('term') && (
          <div
            className={[
              ' flex justify-center items-center bg-gradient-to-r from-slate-400 to-slate-500 shadow-md rounded-md pl-2 pr-1 py-1 text-sm',
              !data.showMore && 'hidden',
            ].join(' ')}
            onClick={() => {
              if (data.termId) {
                navigate('/term', {
                  state: { term: { termUuid: data.termId, termName: data.termName }, termTaxonomy: 'category' },
                });
              } else {
                // Toast.show("查看更多");
              }
            }}
          >
            <div className=" text-nowrap whitespace-nowrap">查看更多</div>
            <AiFillCaretRight
              size={20}
              className=" mb-0.5"
            />
          </div>
        )}
        {/* {true && (
          <div
            className={[' mb-1 flex', !data.showChange && 'hidden'].join(' ')}
            onClick={() => {
              data.onChange();
            }}
          >
            <div className=" text-nowrap whitespace-nowrap">换一批</div>
            <AiOutlineSync size={20} />
          </div>
        )} */}
      </div>

      {/* 内容 */}
      <div
        className={[
          data.maskContent && ' blur-md',
          ' rounded-md shadow-md p-2 bg-gradient-to-br from-sky-100 to-orange-200 min-h-96',
        ].join(' ')}
      >
        <Grid
          columns={albumMode && !data.showChange ? 1 : column}
          gap={8}
        >
          {data?.postList?.map((item, index) => (
            <GridItem key={item.postUuid + '_' + index}>
              <div
                onClick={() => {
                  navigate('/detail', {
                    state: { post: item, term: item.asTerms },
                  });
                }}
              >
                {/* 封面展示 */}
                <div className=" relative flex gap-1 justify-center items-center">
                  {albumMode && !data.showChange ? (
                    // 画廊模式
                    item.postCoverUrlList.map(
                      (coverUrl, index) =>
                        index < 3 && (
                          <Image
                            key={coverUrl}
                            src={coverUrl?.replaceAll('\\', '/').replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                            className=" rounded-md"
                            width={'100%'}
                            style={{ maxWidth: window.innerWidth / 2 }}
                            height={Math.floor(isVertical ? verticleHeight : horizontalHeight)}
                            fit="cover"
                            lazy={true}
                            fallback={
                              <div
                                style={{
                                  background:
                                    'url(' + isVertical
                                      ? img.fallbackVerticalImg
                                      : img.fallbackImg + ') center center / cover no-repeat',
                                  height: Math.floor(isVertical ? verticleHeight : horizontalHeight),
                                }}
                              />
                            }
                            placeholder={
                              <div
                                style={{
                                  background: 'url(' + img.loadingImg + ') center center / cover no-repeat',
                                  height: Math.floor(isVertical ? verticleHeight : horizontalHeight),
                                }}
                              />
                            }
                          />
                        )
                    )
                  ) : (
                    // 单图模式
                    <>
                      <Image
                        src={item.postCoverUrlList[0]
                          ?.replaceAll('\\', '/')
                          .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                        className=" rounded-md rounded-b-none"
                        width={'100%'}
                        height={Math.floor(isVertical ? verticleHeight : horizontalHeight)}
                        fit="cover"
                        lazy={true}
                        fallback={
                          <div
                            style={{
                              background:
                                'url(' + isVertical
                                  ? img.fallbackVerticalImg
                                  : img.fallbackImg + ') center center / cover no-repeat',
                              height: Math.floor(isVertical ? verticleHeight : horizontalHeight),
                            }}
                          />
                        }
                        placeholder={
                          <div
                            style={{
                              background: 'url(' + img.loadingImg + ') center center / cover no-repeat',
                              height: Math.floor(isVertical ? verticleHeight : horizontalHeight),
                            }}
                          />
                        }
                      />
                    </>
                  )}
                  {/* 帖子类型：文字/图片/音频/游戏 */}
                  {!albumMode && (
                    <>
                      <div
                        className=" text-xs absolute top-1 right-1 p-1 rounded-md bg-gradient-to-br from-orange-400/60 to-orange-500/90 text-white bg-opacity-90 shadow-md"
                        onClick={() => {
                          // Toast.show("前往分类, " + item.postType);
                        }}
                      >
                        {postSourceTypeMap.get(item.postSourceType)}
                      </div>
                    </>
                  )}
                  {/* 功能少用，不展示 */}
                  {/* 交互角标：点赞/收藏 */}
                  {/* {!albumMode && (
                      <>
                        <div className=" absolute bottom-1 flex justify-between items-center w-full px-1.5">
                          <AiOutlineHeart
                            color="orange"
                            size={25}
                            className=" p-1 rounded-md bg-gray-500 text-white bg-opacity-60 shadow-md"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();

                              const data = {
                                postId: item?.postUuid,
                                userId: userPolyInfo.asUser.uuid,
                                termId: item.asTerms.termUuid,
                                videoListId: favoritelistId,
                              };
                              // if (liked) {
                              //   // 取消喜欢
                              //   VideoApi.del4List(data);
                              // } else {
                              // 添加喜欢
                              VideoApi.add2List(data);
                              // }
                            }}
                          />
                          <AiOutlineBook
                            color="orange"
                            size={25}
                            className=" p-1 rounded-md bg-gray-500 text-white bg-opacity-60 shadow-md"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              // Toast.show(
                              //   '已收藏'
                              // +
                              //   item.postUuid +
                              //   ", " +
                              //   item.postTitle
                              // );
                              const data = {
                                postId: item?.postUuid,
                                userId: userPolyInfo.asUser.uuid,
                                termId: item.asTerms.termUuid,
                                videoListId: collectListId,
                              };
                              // if (hoard) {
                              //   // 取消收藏
                              //   VideoApi.del4List(data);
                              // } else {
                              // 添加收藏
                              VideoApi.add2List(data);
                              // }
                            }}
                          />
                        </div>
                      </>
                    )} */}
                </div>
                {/* 文字描述 */}
                <div className=" p-1 flex justify-start items-center gap-1 bg-gradient-to-br from-slate-400/80 to-slate-600/80 text-white px-1.5 rounded-t-none rounded-md shadow-md">
                  {/* 帖子类型：文字/图片/音频/游戏 */}
                  {albumMode && (
                    <div
                      className=" text-xs p-1.5 mr-0.5 text-nowrap whitespace-nowrap rounded-md bg-gradient-to-br from-orange-400/60 to-orange-500/90 text-white bg-opacity-90 shadow-md"
                      onClick={() => {
                        // Toast.show("前往分类, " + item.postType);
                      }}
                    >
                      {postSourceTypeMap.get(item.postSourceType)}
                    </div>
                  )}
                  {/* 帖子标题 */}
                  <Ellipsis
                    content={item.postTitle}
                    // rows={albumMode ? 1 : 2}
                    rows={2}
                    className={[albumMode ? '' : 'h-9', ' whitespace-nowrap text-wrap text-start text-xs'].join(' ')}
                  />
                </div>
              </div>
              <div className=" flex flex-wrap justify-between items-center text-sm my-1">
                <div className=" flex justify-center items-center gap-1 text-nowrap">
                  <AiFillFire
                    color="red"
                    className=" opacity-50"
                  />
                  <div>{(item.asCoacts.coactHotIndex / 10000).toFixed(2) + ' w'}</div>
                </div>
                <div className=" flex justify-center items-center gap-1 text-nowrap">
                  <AiFillCloud
                    color="purple"
                    className=" opacity-50"
                  />
                  <div>
                    {Object.prototype.toString.call(item?.postUploadTime) === '[object String]'
                      ? dayjs(item?.postUploadTime).format('MM月DD日')
                      : dayjs(localDatetime2Date(item?.postUploadTime)).format('MM月DD日')}
                  </div>
                </div>
              </div>
            </GridItem>
          ))}
        </Grid>
      </div>

      {/* 换一换*/}
      <center className={[!data.showChange && ' hidden'].join(' ')}>
        <div
          onClick={useThrottledHandler(() => {
            if (globalLoading) {
              return;
            }
            showGlobalLoading({ long: true });

            data.onChange();
          })}
          className=" p-2 m-4 w-24 border-2 border-slate-200 bg-pink-500 bg-opacity-50 text-base text-white rounded-md shadow-md text-center"
        >
          换一换
        </div>
      </center>
      {/* <div className=" flex justify-center text-center ">
        <div
          className={[
            ' my-8 py-1 px-2 flex justify-center items-center gap-1 text-base bg-orange-400 text-slate-100 rounded-md shadow-md ',
            !data.showChange && 'hidden',
          ].join(' ')}
          onClick={useThrottledHandler(() => {
            showGlobalLoading();
            data.onChange();
          })}
        >
          <div>换一换</div>
          <AiOutlineSync size={20} />
        </div>
      </div> */}

      {/* 遮罩 */}
      {data.maskContent && (
        <div
          className="absolute top-0 text-white bg-black bg-opacity-70 rounded-md shadow-md flex justify-center"
          style={{ height: height, width: divRef.current?.clientWidth }}
        >
          <div className=" relative w-full h-full pt-40">
            <div className={' sticky top-80'}>{data.maskContent}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageList;
